import { Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { CSSProperties } from 'react';

interface Props {
  img: string;
  label: string;
  imgStyles?: CSSProperties;
  styles?: SxProps;
  isCompleted?: boolean;
}

const Image = (props: Props) => (
  <img
    src={props.img}
    alt={props.label}
    width={props.imgStyles?.width || 64}
    height={props.imgStyles?.height || 64}
    style={props.imgStyles}
  />
);

const StepItem = (props: Props) => {
  return (
    <Box
      gap={1}
      display={'flex'}
      alignItems={'center'}
      flexDirection={'column'}
      sx={{ ...props.styles }}
    >
      <Box sx={{ position: 'relative', maxWidth: 170 }}>
        {props.isCompleted && (
          <Image
            img='/images/digital_account/completed.png'
            label='completed'
            imgStyles={{ width: 20, height: 20, position: 'absolute', bottom: 12, right: 3 }}
          />
        )}
        <Image {...props} />
      </Box>
      <Typography align='center' sx={{ maxWidth: 142 }} fontSize={16}>
        {props.label}
      </Typography>
    </Box>
  );
};

export default StepItem;
